export default "__VITE_PUBLIC_ASSET__7483889a__"